<template>
  <div class="ts-border ts-p-3 ts-rounded">
    <div class="row">
      <div class="col-md-6 ts-space-y-3">
        <div class="row">
          <label class="required form-col-label control-label col-md-3">{{
            $t('purchaseRequest.prDate')
          }}</label>
          <div class="col-md-7">
            <a-date-picker v-model="model.pr_date" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY" :allowClear="false"
              class="ts-w-full" />
            <div class="validate" v-if="errors.has('pr_date')">
              {{ errors.first('pr_date') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">{{
            $t('purchaseRequest.requiredDate')
          }}</label>
          <div class="col-md-7">
            <a-date-picker v-model="model.required_date" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              :allowClear="false" class="ts-w-full" />
            <div class="validate" v-if="errors.has('required_date')">
              {{ errors.first('required_date') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">{{
            $t('purchaseRequest.customer')
          }}</label>
          <div class="col-md-7">
            <a-select v-model="model.customer_id" :options="customers" class="ts-w-full" showSearch :filterOption="(input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
              " :class="{
                'is-invalid': errors.has('customer_id')
              }"></a-select>
            <div class="validate" v-if="errors.has('customer_id')">
              {{ errors.first('customer_id') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 ts-space-y-3">
        <div class="row">
          <label class="required form-col-label control-label col-md-3">{{
            $t('purchaseRequest.prBy')
          }}</label>
          <div class="col-md-7">
            <a-select v-model="model.pr_by" :options="employees" class="ts-w-full" showSearch :filterOption="(input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
              " :class="{
                'is-invalid': errors.has('pr_by')
              }"></a-select>
            <div class="validate" v-if="errors.has('pr_by')">
              {{ errors.first('pr_by') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">{{
            $t('purchaseRequest.project')
          }}</label>
          <div class="col-md-7">
            <a-select v-model="model.project_id" :options="projects" class="ts-w-full" showSearch :filterOption="(input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
              " :class="{
                'is-invalid': errors.has('project_id')
              }"></a-select>
            <div class="validate" v-if="errors.has('project_id')">
              {{ errors.first('project_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">{{
            $t('purchaseRequest.remarks')
          }}</label>
          <div class="col-md-7">
            <textarea v-model="model.remarks" rows="3" class="form-control ts-w-full"></textarea>
          </div>
        </div>
      </div>
    </div>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'purchaseInfo',
  props: ['value', 'validate'],
  data() {
    return {
      loading: false,
      waiting: false,
      add_new_purchase_type: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('purchaseRequest/purchaseRequest', ['formViewDatas']),
    customers() {
      if (this.formViewDatas['customers']) {
        return this.formViewDatas['customers'].map(el => ({
          value: el.customer_id,
          label: el.customer_name
        }))
      }
      return []
    },
    projects() {
      if (this.formViewDatas['projects']) {
        const projects = this.formViewDatas['projects']

        return projects
          .filter(p => p.customer_id === this.model.customer_id)
          .map(el => ({
            value: el.project_id,
            label: el.project_name
          }))
      }
      return []
    },
    employees() {
      if (this.formViewDatas['employees']) {
        return this.formViewDatas['employees'].map(el => ({
          value: el.employee_id,
          label: el.employee_name_en + '|' + el.employee_name_kh,
          user_id: el.user_id
        }))
      }
      return []
    }
  },
  methods: {},
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseRequest/purchaseRequest/CLEAR_SETUP')
    next()
  }
}
</script>
<style>
.add-select .ant-select-selection {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-calendar-picker-input {
  height: 32px !important;
}
</style>
